import { request as httpRequest } from './http-library.js';
import publicConfig from '../public-config.js';

const ssoHost = publicConfig.external_address;

export const Vendors = {
  read: function readVendors (ssoId, callback) {
    const requestParams = {
      host: ssoHost,
      path: `/v1/projects/vendors?owner_id=${ssoId}`,
      method: 'GET'
    };
    httpRequest(requestParams, function request (response) {
      callback(response);
    });
  }
};
